import { IAIWorkspace, IAIWorkspaceRequest } from "@entities/aiWorkspace";
import { readScriptGenerationMasterPrompt } from "./ScriptGenerationTab/types";

export function hasSavedText(value?: string) {
  return Boolean(
    value
      ?.replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .trim()
  );
}

export function moduleHasSavedPrompt(workspace: IAIWorkspace, moduleId: string) {
  if (moduleId === "creator-fit") return hasSavedText(workspace.creatorFitMasterPrompt?.prompt);
  if (moduleId === "script-vet") return hasSavedText(workspace.scriptVetMasterPrompt?.prompt);
  if (moduleId === "draft-vet") return hasSavedText(workspace.draftVetMasterPrompt?.prompt);
  if (moduleId === "script-generation") {
    return hasSavedText(
      readScriptGenerationMasterPrompt(workspace.scriptGenerationMasterPrompt)?.brief
    );
  }
  return false;
}

export function requestIsWorking(request: IAIWorkspaceRequest, moduleId: string) {
  const matches =
    request.type === moduleId ||
    (moduleId === "script-generation" && request.type === "script-generate");
  return matches && "status" in request && (request as { status?: string }).status === "working";
}
